require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-nepal-ssdp.json") })
        }
      }, "path---en-us-project-nepal-ssdp");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-nepal-ssdp!./.cache/json/en-us-project-nepal-ssdp.json
// module id = 547
// module chunks = 231608221292675